<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div>
      <filter-manager  
        v-model="filterDataModel"
        ref="filterManager"
        :display-advanced="false"
        :filters="filterManagerConfig"
        :is-advanced="false"
        search-text="Procesar"
        search-icon="fa fa-sync"
        search-container-class="custom-btn-process"
        @search="processReport"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Solicitud de Consulta de Ubicación de Estudiantes',
      routes: ["Informes", "Solicitud de Consulta de Ubicación de Estudiantes"]
    },
    filterDataModel: {
      sie: null,
      csee: null,
      municipality: null,
      schoolType: null,
      school: null,
      academicYear: null,
    },
    collections: {
      academicYears: [],      
      csee: [],
      municipalities: [],
      schoolType: [],
      schools: [],
    }
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filterDataModel.academicYear,
          class: 'col-sm-4 col-md-2',
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          error: 'El año académico es obligatorio.',
        },
        {
          name: 'csee',
          component: 'CustomDropDown',
          options: this.collections.csee,
          value: this.filterDataModel.csee,
          class: 'col-sm-4 col-md-2',
          placeholder: 'CSEE',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'municipality',
          component: 'CustomDropDown',
          options: this.collections.municipalities,
          value: this.filterDataModel.municipality,
          class: 'col-sm-4 col-md-2',
          placeholder: 'Municipio',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'schoolType',
          component: 'CustomDropDown',
          options: this.collections.schoolType,
          value: this.filterDataModel.schoolType,
          class: 'col-sm-4 col-md-2',
          placeholder: 'Tipo de Escuela',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'school',
          component: 'CustomDropDown',
          options: this.collections.schools,
          value: this.filterDataModel.school,
          class: 'col-sm-4 col-md-2',
          placeholder: 'Escuela',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          class: 'col-sm-2',
          placeholder: 'Escriba Número de SIE',
          value: this.filterDataModel.sie,
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          type: 'text',
          validations: 'digits:8',
          error: 'SIE invalido.',
        },
      ]
    },
  },
  watch: {
    async 'filterDataModel.academicYear'() {
      this.filterDataModel.csee = null;
      this.filterDataModel.municipality = null;
      this.filterDataModel.school = null;
      await this.populateFilters();
    },
    async 'filterDataModel.csee'() {
      this.filterDataModel.municipality = null;
      this.filterDataModel.school = null;
      await this.populateFilters();
    },
    async 'filterDataModel.municipality'() {
      this.filterDataModel.school = null;
      await this.populateFilters();
    },
    async 'filterDataModel.schoolType'() {
      this.filterDataModel.school = null;
      await this.populateFilters();
    }
  },
  async mounted() {
    await this.populateFilters();
  },
  methods: {
    async populateFilters() {
      const payload = {
        academicYearId: this.filterDataModel.academicYear?.id,
        centerId: this.filterDataModel.csee?.id,
        municipalityId: this.filterDataModel.municipality?.id,
        schoolTypeId: this.filterDataModel.schoolType?.id,
      };
      const { data } = await CodeApiServices.GetStudentRequestLocationParams(payload);

      this.collections = {...data};
    },
    async processReport() {
      const isValid = await this.$refs.filterManager.$refs.formValidator.validate();
      if (!isValid) return;

      const res = await reportApi.getReport('getstudentrequestlocation', {
        academicYearId: this.filterDataModel.academicYear.id,
        studentSieId: this.filterDataModel.sie,
        centerId: this.filterDataModel.csee?.id,
        municipalityId: this.filterDataModel.municipality?.id,
        schoolTypeId: this.filterDataModel.schoolType?.id,
        schoolId: this.filterDataModel.school?.id,
      });

      DocumentsService.Download(res.data);
    }
  },
}
</script>

<style scope>
.custom-btn-process {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 10%;
  flex: 0 0 10%;
  max-width: 10%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0.25rem !important;
}
</style>

